var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFeaturedSnippet16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.227295C0.447715 0.227295 0 0.67501 0 1.2273V11.6385C0 12.1907 0.447715 12.6385 1 12.6385H15C15.5523 12.6385 16 12.1907 16 11.6385V1.22729C16 0.67501 15.5523 0.227295 15 0.227295H1ZM8.28709 2.72073C8.20075 2.4373 7.79948 2.4373 7.71313 2.72073L7.08517 4.78208C7.0467 4.90836 6.9302 4.99466 6.79819 4.99466H4.72695C4.44104 4.99466 4.31719 5.35666 4.5432 5.53179L6.25143 6.85554C6.34986 6.93181 6.39094 7.06097 6.35465 7.18009L5.71012 9.29583C5.62487 9.57567 5.94963 9.79957 6.18086 9.62039L7.81635 8.35302C7.92452 8.2692 8.0757 8.2692 8.18387 8.35302L9.81936 9.62039C10.0506 9.79958 10.3753 9.57567 10.2901 9.29583L9.64557 7.18009C9.60928 7.06097 9.65036 6.93181 9.74879 6.85553L11.457 5.53179C11.683 5.35666 11.5592 4.99466 11.2733 4.99466H9.20203C9.07002 4.99466 8.95352 4.90836 8.91505 4.78208L8.28709 2.72073Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81812 12.6384L2.25946 9.8992C1.93067 9.64612 1.45448 9.8805 1.45448 10.2954V14.9815C1.45448 15.3964 1.93067 15.6308 2.25946 15.3777L5.81812 12.6384Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeaturedSnippet16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;